import React from "react";

function InstaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      fill="none"
      viewBox="0 0 17 16"
    >
      <path
        fill="#000"
        d="M14.416 5.537a4.246 4.246 0 00-.287-1.478 3.066 3.066 0 00-.713-1.062 3.173 3.173 0 00-1.094-.693 4.648 4.648 0 00-1.5-.28c-.66-.029-.869-.037-2.544-.037s-1.89 0-2.545.037c-.513.01-1.02.105-1.5.28-.41.154-.782.39-1.093.692a3.064 3.064 0 00-.712 1.063c-.181.466-.278.959-.288 1.457-.03.642-.038.845-.038 2.473s0 1.836.038 2.474c.01.498.107.99.288 1.458.159.398.401.76.713 1.062.31.302.683.538 1.094.692.478.182.985.284 1.499.3.66.029.87.038 2.545.038 1.675 0 1.89 0 2.545-.038a4.638 4.638 0 001.5-.279c.41-.155.782-.39 1.093-.693a3.07 3.07 0 00.713-1.062c.18-.467.277-.959.287-1.458.03-.642.039-.845.039-2.474-.002-1.628-.002-1.834-.04-2.472zm-6.142 5.531c-1.752 0-3.172-1.38-3.172-3.082 0-1.703 1.42-3.082 3.172-3.082.841 0 1.648.325 2.243.903.594.578.928 1.362.928 2.179 0 .817-.334 1.601-.928 2.18a3.219 3.219 0 01-2.243.902zm3.298-5.56a.728.728 0 01-.74-.718.7.7 0 01.217-.508.741.741 0 01.522-.21.758.758 0 01.523.21.717.717 0 01.216.508c0 .397-.33.719-.738.719z"
      ></path>
      <path
        fill="#000"
        d="M8.274 9.988c1.138 0 2.06-.896 2.06-2.002 0-1.105-.922-2.002-2.06-2.002s-2.06.897-2.06 2.002c0 1.106.922 2.002 2.06 2.002z"
      ></path>
    </svg>
  );
}

export default InstaIcon;
